import { defineStore } from 'pinia';
import { usePlayCanvasStore } from './playCanvas';

export const usePlayPreviewCanvasStore = defineStore('playPreviewCanvas', {
  state: () => ({
    pathviewPreviewActive: false, // Are we previewing?
    showPreview: true, // Can we see the preview?
    showPathView: true, // Can we see the path view?
    pathviewDataReady: false,
    scenePosLookup: {},
    pathViewSceneCacheState: {},
    showURLPreviewDialog: false,
    externalUrlPreviewLinks: {
      iosUrl: '',
      androidUrl: '',
      onClickUrl: '',
      action: '',
    },
    connectedNodes: {} as { visible: boolean; targets: { to: string; from: string; route: string }[], x: number, y: number; },
    visibleRoute: '',
    connections: {} as { [key: string]: Array<string | number> },
    scenePath: {} as {[key: string]: Array<string | number>},
    audioTrigger: false,
    zoomScale: 1, // current pathview zoom scale
  }),

  actions: {
    setSelectedPath(selectedPath: string | string[]): void {
      const playCanvasStore = usePlayCanvasStore();
      playCanvasStore.setSelectedPath(selectedPath);

      // The only time we need to autoplay is when we arrive
      //  at a new scene that has autoplay enabled on the main video,
      //  but only in the preview.

      // This autoplay implementation commented out until we figure out the video autoplay on first scene
      // Current autoplay implementation is on usePreviewLayer
      // if (playCanvasStore.showPreview
      //   && playCanvasStore.getCurrentSceneIndex !== 0
      //   && playCanvasStore.getCurrentSceneLength !== 0
      // ) playTimelineStore.autoplaySceneIfApplicable();
    },

    triggerExternalURLPreview(givenUrls:
      {
        iosUrl: string | '',
        androidUrl: string | '',
        onClickUrl: string | '',
        action: string | '',

      }): void {
      this.externalUrlPreviewLinks = givenUrls;
      this.showURLPreviewDialog = true;
    },
  },
});

export default usePlayPreviewCanvasStore;
